import { PlaceholderPage } from './PlaceholderPage';

export const ChartOfAccountsPage = () => <PlaceholderPage title="Chart of Accounts" />;
